module.exports = __webpack_public_path__ + "img/flag_rect_230.2e5a984e.png";